import { RootState, useThree } from "@react-three/fiber";
import { useEffect } from "react";

interface ISceneProps {
  handleSetProps: (rootState: RootState) => void;
}

const SceneProps = ({ handleSetProps }: ISceneProps) => {
  const rootState = useThree();

  useEffect(() => {
    handleSetProps(rootState);
  }, []);

  return null;
};

export default SceneProps;
